import { useParams, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import { useEffect, useState } from "react";
import { CheckCircle2, ArrowLeft, Dot } from "lucide-react";
import { FaAngleLeft } from "react-icons/fa";
import CourseActivatedModal from "./CourseActivatedModal";

function Checkoutpage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [data, setData] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setPageLoading(true);

      try {
        const response = await axios.get("getAllCourses");

        if (response?.data) {
          const result = response?.data?.result.find((el) => el._id === id);

          if (result) {
            setData(result);
          
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setPageLoading(false);
      }
    }

    fetchData();
  }, [id]);

  const handlePayment = () => {
    setLoading(true);

    axios
      .post("createOrder", {
        courseId: id,
      })
      .then((response) => {
        if (response?.data) {
          window.location.href = response?.data?.result?.upiLink;
          
        }
          // setShowSuccessModal(true);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const discountPercentage =
    data.price && data.offerPrice
      ? Math.round(((data.price - data.offerPrice) / data.price) * 100)
      : 0;

  if (pageLoading) {
    return (
      <div className="min-h-screen flex  bg-[#F8F5FC]">
        <div className="w-10 h-10 border-4 border-[#4B1D67] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F5F2F8] pb-36 lg:pb-10 lg:pt-8">
      <div className="bg-[#EEE8F4] px-4 lg:px-10 pt-6 pb-6  lg:pb-10">
        {/* BACK BUTTON */}
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 rounded-full bg-white/30 flex items-center justify-center mb-2"
        >
          <FaAngleLeft size={28} />
        </button>

        {/* HEADER */}
        <div className="flex items-start gap-0 lg:gap-4">
          {/* LEFT SIDE */}
          <div className="flex flex-col items-start">
            {/* IMAGE */}
            <div className="w-16 h-16 lg:w-20 lg:h-20 bg-[#4B1D67] rounded-full flex items-center justify-center flex-shrink-0">
              <img
                src={data.planImage}
                alt=""
                className="w-8 h-8 lg:w-10 lg:h-10 object-contain"
              />
            </div>

            {/* BUTTON IMAGE KE NICHE */}
            <button className="mt-4 bg-[#F5A623] text-white px-2 py-2 font-timesNewRoman rounded-[8px]  text-sm shadow-md">
              Special Plan
            </button>
          </div>

          {/* DETAILS */}
          {/* DETAILS */}
          <div className="flex flex-col items-start text-left">
            <h1 className="text-xl lg:text-2xl font-bold text-[#4B1D67]">
              {data.planName}
            </h1>

            <div className="flex flex-wrap items-center gap-1 lg:gap-3 mt-3">
              <span className="line-through text-gray-500 text-sm lg:text-xl">
                ₹{data.price}
              </span>

              <span className="text-[#4B1D67] text-lg lg:text-3xl font-bold">
                ₹{data.offerPrice}
              </span>

              <span className="text-green-600 text-sm lg:text-xl">
                ({discountPercentage}% Off)
              </span>

              <span className="border-2 border-[#4B1D67] bg-white px-2 py-1 rounded-xl text-sm lg:text-md text-[#4B1D67]">
                Limited Offers
              </span>
            </div>
          </div>

          {/* DESKTOP EXAMS RIGHT SIDE */}
          <div className="hidden lg:block min-w-[300px]">
            <h2 className="text-xl font-bold mb-2 text-right">Exams Covered</h2>

            <div className="flex flex-wrap gap-2 text-right justify-end">
              {data?.exams?.map((exam, i) => (
                <div
                  key={i}
                  className="bg-[#5A2D78] text-white px-3 py-2 rounded-[8px] text-sm "
                >
                  {exam.examName}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="px-4 lg:px-10 py-4 grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* LEFT */}
        <div className="items-center w-full">
          {/* EXAMS */}
          <div className="lg:hidden mb-5 w-full">
            <h2 className="text-xl font-bold mb-2 text-center w-full">
              Exams Covered
            </h2>

            <div className="flex flex-wrap gap-2">
              {data?.exams?.map((exam, i) => (
                <div
                  key={i}
                  className="bg-[#5A2D78] text-white px-3 py-2 rounded-[8px] text-sm font-timesNewRoman"
                >
                  {exam.examName}
                </div>
              ))}
            </div>
          </div>

          {/* PLAN BENEFITS */}
          <div className="w-full lg:pt-2">
            <h2 className="text-xl font-bold lg:mt-2 mb-2 lg:mb-2 text-left w-full ">
              Plan Benefits
            </h2>

            <div className="bg-white text-16px rounded-[20px] p-2 lg:p-10 shadow-sm">
              <div className="space-y-1">
                {[
                  "1,00,000 Questions Access",
                  "Unlimited Quiz Attempts",
                  "Performance Tracking & Rewards",
                  "24×7 Support",
                  "Daily Login Rewards",
                  "Topics & Subject Included ↓",
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <Dot className="text-[#5A2D78]" size={24} />

                    <p className="text-sm">{item}</p>
                  </div>
                ))}
              </div>

              {/* EXTRA TAGS */}
              <div className="flex flex-wrap gap-4 mt-5">
                {data?.subject?.map(
                  (item, i) => (
                    <div
                      key={i}
                      className="bg-[#F8C35A] px-3 py-2 rounded-[8px] font-bold text-sm text-[#4B1D67]"
                    >
                      {item}
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        {/* INFO CARDS */}
        <div className="w-full overflow-x-auto lg:mt-10 no-scrollbar">
          <div className="flex gap-5 min-w-max">
            {/* CARD 1 */}
            <div className="bg-[#F1EAF7] rounded-[35px] p-6 max-w-[400px] lg:min-w-[500px]">
              <h2 className="text-xl font-bold mb-4 text-left">
                Rewards & Scoring Info
              </h2>

              <div className="space-y-1 text-gray-800">
                {[
                  
                  "Performance-based rewards on your quiz results",
                  "Correct answer earns Credits, incorrect or skipped may reduce Credits",
                  "Credits wallet updates instantly after each quiz submission",
                  "The remaining amount between the original plan price and the discounted purchase price will be automatically recovered from your future contest rewards until the full amount has been adjusted.",
                ].map((item, index) => (
                  <div key={index} className="flex gap-2 text-start">
                    <Dot className="mt-1 shrink-0 text-gray-500 text-start" />
                    <p className="text-sm leading-9">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* CARD 2 */}
            <div className="bg-[#F1EAF7] rounded-[35px] p-6 min-w-[80px] lg:min-w-[500px]">
              <h2 className="text-xl font-bold mb-4 text-left">Performance Tracking</h2>

              <div className="space-y-1 text-gray-800">
                {[
                  "Weekly leaderboard and rank analysis",
                  "Compare performance with other students",
                  "Earn badges for top performance",
                  "Real-time progress reports available",
                ].map((item, index) => (
                  <div key={index} className="flex gap-2 text-left">
                    <Dot className="mt-1 text-gray-500" />
                    <p className="text-sm leading-9">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE FIXED BUTTON */}
<div className="
  fixed bottom-0 left-0 lg:left-[260px]
  w-full lg:w-[calc(100%-260px)]
  bg-[#FFF3DD]
  p-8 lg:px-10
  rounded-t-[35px]
  shadow-2xl
  z-50
  border-t-1 border-gray-300
">  
  <div className="w-4xl mx-auto flex items-center justify-between gap-4">

    {/* PRICE */}
   <div className="flex items-end gap-2 flex-wrap">
  
  <span className="text-md lg:text-3xl font-bold text-[#4B1D67]">
    ₹{data.offerPrice}
  </span>

  <span className="line-through text-gray-400 text-sm lg:text-xl">
    ₹{data.price}
  </span>

  <p className="text-[#E3A72F] text-sm lg:text-lg whitespace-nowrap">
    with GST
  </p>

</div>

    {/* BUTTON */}
    <button
      onClick={handlePayment}
      disabled={loading}
      className="
        bg-[#4B1D67]
        text-white
        px-6 lg:px-10
        py-4 lg:py-4
        rounded-[20px]
        text-sm lg:text-xl
        font-semibold
        whitespace-nowrap
      "
    >
      {loading ? "Processing..." : "Unlock Course Now"}
    </button>

  </div>
</div>
      {/* Description */}
      <div className="w-full lg:pb-20">
  <h2 className="text-xl font-bold text-left pl-5 w-full">
    Description
  </h2>

  <div className="p-6 lg:p-10 shadow-sm">
    <div className="space-y-1">
      {[
        "Performance rewards can be used for withdrawal or joining contests.",
        "Performance rewards are non-transferable.",
        "By purchasing, you agree to Terms & Conditions, Privacy Policy and Refund Policy applicable.",
      ].map((item, index) => (
        <div
          key={index}
          className="flex items-start gap-3 text-left"
        >
          <Dot
            className="text-[#5A2D78] mt-1 flex-shrink-0"
            size={22}
          />

          <p className="text-sm leading-6 text-[#333]">
            {item}
          </p>
        </div>
      ))}
    </div>
  </div>
</div>
<CourseActivatedModal
  isOpen={showSuccessModal}
  onClose={() => setShowSuccessModal(false)}
  courseName={data?.planName}
  onStartLearning={() => {
    navigate("/dashboard");
  }}
  onGoDashboard={() => {
    navigate("/dashboard");
  }}
/>
    </div>
    
  );
}

export default Checkoutpage;
